import { render, staticRenderFns } from "./AssembliesList.vue?vue&type=template&id=11938a24&"
import script from "./AssembliesList.vue?vue&type=script&lang=js&"
export * from "./AssembliesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports